<template>
    <div>
        <div v-if="itens">
            <h5 class="heading-1 mt-2" v-if="!isModal">
                <span>TIMELINE</span>
            </h5>
            <ul class="timeline mt-4" id="timeline">
                <li
                    class="li"
                    :class="{
                        complete: item.concluido && !item.atencao,
                        next: !item.concluido && item.proximo,
                        near: !item.concluido && !item.proximo,
                        notok: item.concluido && item.atencao
                    }"
                    v-for="item in itens"
                    :key="`${item.status}-${item.data}-${item.formaContato}`"
                >
                    <span class="statusSpan">{{ item.status }}</span>
                    <div class="status">
                        <i
                            class="fa"
                            :class="{
                                'timeline-icon fa-exclamation-triangle':
                                    item.concluido && item.atencao,
                                'timeline-icon fa-check':
                                    item.concluido && !item.atencao,
                                'timeline-icon2 fa-hourglass-half':
                                    !item.concluido && item.proximo,
                                'timeline-icon2 fa-times':
                                    !item.concluido && !item.proximo
                            }"
                        ></i>
                    </div>
                    <div class="timestamp" v-if="item.usuario">
                        <span>{{
                            item.usuario
                        }}</span>
                        <span class="date" v-if="item.formaContato">{{
                            item.formaContato
                        }}</span>
                        <span class="date" v-if="item.data">{{
                            $moment(item.data).format('DD/MM/YYYY HH:mm')

                        }}</span>
                        <span class="tempo" v-if="mostrarDias(item)"
                            >{{
                                mensagemDias(item)
                            }}
                        </span>
                    </div>
                </li>
            </ul>
            <time-line-progress-bar-operacionalizacoes
                :progress= "progresso"
                >
            </time-line-progress-bar-operacionalizacoes>
            <br />
            <div class="total-time" v-if="ultimoItem.data">
                TEMPO TOTAL: &nbsp;
                <span>
                    <strong>
                        {{
                            diasTotais
                        }}
                        DIAS</strong
                    ></span
                >
            </div>

            <div class="obs">
                <span>
                    *A medida de dias é dada em dias úteis
                </span>
            </div>
            <div class="text-container">
                <p class="top-text">Informação importante:</p>
                <p class="bottom-text">Caso o documento enviado esteja incorreto, o status retorna para análise, podendo haver múltiplas devolutivas.</p>
            </div>
            <div class="obs-icons">
                <span>
                    <i class="fa timeline-icon-check fa-check"></i>Concluído
                </span>
                <span>
                    <i class="fa timeline-icon-half fa-hourglass-half"></i>Em Andamento
                </span>
                <span>
                    <i class="fa timeline-icon-times fa-times"></i>Pendente
                </span>
            </div>
        </div>
        <div v-if="!itens">
            <i class="fa fa-circle-o-notch fa-spin fa-2x"></i>
        </div>
    </div>
</template>

<script>
import TimeLineProgressBarOperacionalizacoes from './TimeLineProgressBarOperacionalizacoes.vue'

export default {

    components: {
        TimeLineProgressBarOperacionalizacoes
    },
    name: 'TimeLineOperacionalizacoes',

    props: {
        itens: {
            type: Array,
            default: () => [{}]
        },
        isModal: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {}
    },

    methods: {
        mostrarDias(tl) {
            if (tl.diasUteis != null) {
                return true
            }
            return false
        },

        mensagemDias(tl) {
            if (tl.diasUteis <= 0) {
                return '0 dia(s)'
            }
            return `${tl.diasUteis} dia(s)`
        }
    },

    computed: {
        primeiroItem() {
            if (this.itens) {
                return this.itens[0]
            }
        },

        ultimoItem() {
            if (this.itens) {
                return this.itens[this.itens.length - 1]
            }
        },

        diasTotais() {
            let dias = 0
            for (let item in this.itens) {
                let tl = this.itens[item]
                dias += tl.diasUteis > 0 ? tl.diasUteis : 0
            }
            return dias
        },

        progresso() {
            if (this.itens && this.itens.length > 0) {
                const totalEtapas = this.itens.length;
                const etapasConcluidas = this.itens.filter(item => item.concluido).length;

                // Verifica se o último item representa o fim do processo
                const ultimo = this.itens[this.itens.length - 1];

                if (ultimo && ultimo.concluido) {
                    return 100;
                }

                return Math.min((etapasConcluidas / totalEtapas) * 100, 100);
            }
            return 0;
        }
    }
}
</script>

<style scoped>
.timeline {
    list-style-type: none;
    display: flex;
    flex-wrap: nowrap;
    padding-inline-start: 0px !important;
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    overflow-x: auto;
}

.li {
    transition: all 200ms ease-in;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 200px;
    margin-bottom: 15px;
    margin-right: 10px;
    position: relative;
}

.timestamp {
    margin-bottom: 0px;
    padding: 0px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: relative;
    line-height: 1.5;
    vertical-align: middle;
    font-weight: 500;
    min-width: 100px;
}

.status {
    padding: 15px 0px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    border-top: 2px solid #d6dce0;
    position: relative;
    transition: all 200ms ease-in;
    min-width: 200px;
    background-color: white;
}

.statusSpan {
    width: 130px;
    padding: 0px 0px;
    height: 100px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: relative;
    line-height: 1.5;
    vertical-align: middle;
    transition: all 200ms ease-in;
    font-weight: 700;
}

.status:before {
    content: '';
    width: 30px;
    height: 30px;
    background-color: white;
    border-radius: 25px;
    border: 1px solid #ddd;
    position: absolute;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    transition: all 200ms ease-in;
}

.li.complete .status {
    border-top: 2px solid #66dc71;
}

.li.complete .status:before {
    background-color: #66dc71;
    border: none;
    transition: all 200ms ease-in;
}

.li.complete .status i {
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    justify-content: center;
}

.li.complete .statusSpan {
    color: #666666;
}

.li.next .status {
    border-top: 2px solid #f6ab21;
}

.li.next .status:before {
    background-color: #f6ab21;
    border: none;
    transition: all 200ms ease-in;
}

.li.next .status i {
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    justify-content: center;
}

.li.next .statusSpan {
    color: #f6ab21;
}

.li.near .status {
    border-top: 2px solid #666666;
}

.li.near .status:before {
    background-color: #fff;
    border: 1px solid #ddd;
    transition: all 200ms ease-in;
}

.li.near .status i {
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    justify-content: center;
}

.li.near .statusSpan {
    color: #666666;
}

.li.notok .status {
    border-top: 2px solid #d60000;
}

.li.notok .status:before {
    background-color: #d60000;
    border: none;
    transition: all 200ms ease-in;
}

.li.notok .status i {
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    justify-content: center;
}

.li.notok .statusSpan {
    color: #d60000;
}

.timeline-icon {
    top: -16% !important;
    left: 50% !important;
    transform: translateX(-50%);
}

.timeline-icon2 {
    top: -16% !important;
    left: 50% !important;
    color: #666666;
    transform: translateX(-50%);
}

.obs {
    text-align: center;
    font-weight: 700;
    margin-top: 5px;
    margin-bottom: 10px;
}

.obs-icons {
    text-align: center;
}

.obs-icons .timeline-icon-check{
    margin-left: 15px;
    margin-right: 5px;
    background-color: #66dc71;
    color: #666666;
    border-radius: 80%;
    padding: 8px;

}

.obs-icons .timeline-icon-half{
    margin-left: 15px;
    margin-right: 5px;
    background-color: #f6ab21;
    border: 1px solid #f6ab21;
    color: #666666;
    border-radius: 80%;
    padding: 8px;

}

.obs-icons .timeline-icon-times{
    margin-left: 15px;
    margin-right: 5px;
    background-color: #fff;
    border: 1px solid #ddd;
    color: #666666;
    border-radius: 80%;
    padding: 8px;
}

.total-time {
    text-align: center;
}

span.tempo {
    margin-top: -100px !important;
    margin-left: -185px !important;
    width: 100% !important;
}

.text-container {
    display: flex;
    flex-direction: column;
    justify-content: center; /* Centraliza verticalmente */
    align-items: center; /* Centraliza horizontalmente */
    text-align: center; /* Centraliza o texto */
    width: 100%; /* Ocupa toda a largura */
    height: 100%; /* Ajuste conforme necessário */
}

.top-text {
    font-weight: bold;
    /*margin-bottom: 10px;  Espaçamento entre os textos */
}

.bottom-text {
    font-style: italic;
    margin-top: -10px; /* Espaçamento entre os textos */
}

@media (min-device-width: 320px) and (max-device-width: 700px) {
    .timeline {
        display: block;
    }

    .li {
        width: 100%;
    }

    .timestamp, .status {
        width: 100%;
    }

    .status:before {
        left: 50%;
        transform: translateX(-50%);
    }

/* .p {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    height: 100%;
}

.top-text {
    margin-top: 0;
}

.bottom-text {
    margin-bottom: 0;
} */

}

/* html,
body {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    font-family: 'Titillium Web', sans serif;
    color: #758d96;
} */
</style>

